<script>
import options from './FormConfirmSubmitDialog.options'
export default options
</script>

<template>
  <div
    v-if="isOpen"
    class="kb-form-confirm-submit-dialog"
    @keydown.tab="tabTrap"
  >
    <div
      class="kb-form-confirm-submit-dialog__backdrop"
      @click="onBackdropClick"
    >
      <div
        class="kb-form-confirm-submit-dialog__panel"
        role="dialog"
        aria-modal="true"
        :aria-labelledby="titleId"
        :aria-describedby="descriptionId"
      >
        <div class="kb-form-confirm-submit-dialog__layout">
          <div
            class="kb-form-confirm-submit-dialog__icon kb-ui-icon kb-ui-icon--ui-return-bag"
            aria-hidden="true"
          ></div>

          <h2 :id="titleId" class="kb-form-confirm-submit-dialog__title">
            {{ title }}
          </h2>

          <p :id="descriptionId" class="kb-form-confirm-submit-dialog__text">
            {{ text }}
          </p>

          <div class="kb-form-confirm-submit-dialog__actions">
            <button
              ref="confirmButtonRef"
              type="button"
              class="kb-button kb-button--full-color-spot"
              data-order="first"
              @click="confirm"
            >
              {{ confirmLabel }}
            </button>
            <button
              ref="cancelButtonRef"
              type="button"
              class="kb-button kb-button--spot-border-color kb-form-confirm-submit-dialog__cancel"
              data-order="last"
              @click="close"
            >
              {{ cancelLabel }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
